<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >
    <notifications></notifications>
    <side-bar :active-color="sidebarBackground" :data-background-color="sidebarBackgroundColor">
      <!-- <user-menu></user-menu> -->
      <!-- <mobile-menu></mobile-menu> -->
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'dashboard',
            path: '/dashboard',
            isActive: true
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Screens',
            icon: 'desktop_windows',
            path: '/kiosks',
            isActive: true
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Flavors',
            path: '/flavors',
            isActive: true,
            icon: 'eco'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Locations',
            icon: 'place',
            path: '/locations',
            isActive: true
          }"
        ></sidebar-item>

        <sidebar-item :link="{ name: 'Settings', icon: 'settings', isActive: true }">
          <sidebar-item :link="{ name: 'Users', path: '/register', isActive: true }"></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import { db, auth } from "@/config/firebaseInit";
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
// import MobileMenu from "./Extra/MobileMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    // MobileMenu,
    ZoomCenterTransition
  },
  computed: {
    // currentUser() {
    //   console.log(auth.currentUser.uid)
    //   return auth.currentUser.uid;
    // }
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      clients: [],
      currentUser: {},
      kiosks: []
    };
  },
  firestore() {
    // if (this.currentUser) {
    return {
      currentUser: db
        .collection("administrator")
        .where("uid", "==", auth.currentUser.uid)
    };
    // }
  },

  methods: {
    permissions(target) {
      if (this.currentUser[0]) {
        let route = this.currentUser[0].permissions.filter(
          p => p.name === target
        )[0];

        return route;
      }

      return false;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
